import { NAME } from './constants'

export const getProcessesList = (state) => state[NAME].processesList
export const getAuditList = (state) => state[NAME].auditList
